import React, { useRef, useState } from "react";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import Reactportal from "../../Reactportal/Reactportal";
import Button from "../../Button/Button";
import { useLazyQuery } from "@apollo/client";
import { GetGSTDetailsByGSTNo } from "../../../../Utils/AllPagesQuriesAndMutations";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import Spinner from "../../Spinner/Spinner";

const Loadfilds = [
  {
    id: Math.random() * 10,
    name: "GST_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "GST_Number",
        label: "GSTIN",
        type: "text",
        AllCaps: true,
        min: 1,
        max: 15,
      },
    ],
  },
];

const validateGST = (gst) => {
  const gstRegex = /^([0-9]{2})([A-Z]{5})([0-9]{4})([A-Z]{1})([1-9A-Z]{1})([Z]{1})([0-9A-Z]{1})$/;
  return gstRegex.test(gst);
};

const formatAddress = (addr) => {
  return Object.values({
    flno: addr.flno,
    bnm: addr.bnm,
    bno: addr.bno,
    st: addr.st,
    locality: addr.locality,
    loc: addr.loc,
    dst: addr.dst,
    stcd: addr.stcd,
    pncd: addr.pncd,
  })
    .filter((value) => value && value.trim() !== "")
    .join(", ");
};

const GetGSTINDetailsModal = ({ toggle, setToggle, fillGSTField }) => {
  const formRef = useRef({});
  const [FormData, setFormdata] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const Form_Key = "GST_Details";
  const [getGSTDetailsByNo, { loading: getGSTDetailsByNoLoader }] = useLazyQuery(GetGSTDetailsByGSTNo, {
    fetchPolicy: "network-only",
  });

  const HanldeChangeonForm = (values) => {
    // console.log(values, "Formdata_without_redux1");
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  let Closeformfunction = () => {
    setToggle();
  };

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  let FetchEwbData = () => {
    if (validateGST(FormData?.GST_Number)) {
      getGSTDetailsByNo({ variables: { gstNo: FormData?.GST_Number } })
        .then((res) => {
          let GSTData = res?.data?.getGSTDetailsByGSTNo;
          if (GSTData) {
            let paraddr = formatAddress(GSTData?.pradr?.addr);
            fillGSTField(GSTData?.tradeNam, GSTData?.pradr?.addr?.pncd, GSTData?.gstin, paraddr);
            Closeformfunction();
          }
        })
        .catch((err) => console.log(err));
    } else {
      ErrorToast("Insert Valid Ewb Number");
    }
  };

  return (
    <>
      <div>
        <Reactportal open={toggle} onClose={Closeformfunction} TypeOfPortal={"Get GSTIN Details"}>
          <div className="formContainer">
            {Loadfilds &&
              Loadfilds?.map((e) => {
                return (
                  <div key={e.id} className="FormSectionParent">
                    {/* <div className="sectionHeadings">Get GSTIN Details</div> */}
                    <div className="FormSection insidecontainer">
                      <FormInputSectionComponent
                        inputfields={e.fields}
                        Type={e.name}
                        TypeOfPortal={"Add"}
                        onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                        formkey={Form_Key}
                        onhandleFormikChange={HanldeChangeonForm}
                        formRef={formRef}
                      />
                    </div>
                  </div>
                );
              })}
            {getGSTDetailsByNoLoader ? (
              <Button type="" text={<Spinner />} action="" disabled={true} children="" name="" />
            ) : (
              <Button
                action={() => FetchEwbData()}
                text={"Get Details"}
                name="ewaybtn"
                type={""}
                children={""}
                disabled={""}
              />
            )}
          </div>
        </Reactportal>
      </div>
    </>
  );
};

export default GetGSTINDetailsModal;
